module.exports = __webpack_public_path__ + "7a3c63c832184ddd500a52a8a6decba0.svg";